import React from 'react';

import Text from './Text';
import Box from './layout/Box';

function DocumentSection({ title, subtitle, texts }) {
  return (
    <Box
      className="mt-3"
      style={{
        flexDirection: 'column',
      }}
    >
      {title && <Text variant="documentSectionTitle">{title}</Text>}
      {subtitle && <Text variant="documentSectionSubtitle">{subtitle}</Text>}
      {texts?.map((text, textIndex) => {
        return (
          <Box className="mt-1" key={textIndex.toString()}>
            <Text variant="documentSectionText">{text}</Text>
          </Box>
        );
      })}
    </Box>
  );
}

export default DocumentSection;
